import { QRCodeSVG } from "qrcode.react";
import Certificate_BG from "../_icons/certificate-v2-svg.svg";

interface CertificateV2Props {
  name?: string;
  courseName?: string;
  issueDate?: string;
  qrCode?: string;
  passportNumber?: string | null | undefined;
}

export default function CertificateV2({
  name = "-",
  courseName = "-",
  issueDate = "-",
  qrCode,
  passportNumber = "-",
}: CertificateV2Props) {
  return (
    <div
      className="bg-cover bg-center bg-no-repeat w-full h-[700px] relative"
      style={{ backgroundImage: `url(${Certificate_BG})` }}
    >
      <div className="pl-20 pt-[5.1rem]">
        <img className="h-10" src="/images/logo.svg" />

        <div className="mt-14">
          <h6 className="text-theme-slate-600 text-xs font-normal font-montserrat">
            Issue Date:
          </h6>
          <h5 className="text-theme-slate-600 text-base font-medium font-montserrat mt-1">
            {issueDate || "-"}
          </h5>
        </div>

        <div className="mt-10">
          <h5 className="text-theme-slate-600 text-base font-medium font-montserrat">
            This Certificate is awarded to
          </h5>
          <h2 className="text-theme-zinc-700 text-2xl font-normal font-libre uppercase mt-2.5">
            {name || "-"}
          </h2>
        </div>

        <div className="mt-10">
          <h6 className="text-theme-slate-600 text-xs font-normal font-montserrat">
            Passport Number:
          </h6>
          <h5 className="text-theme-slate-600 text-base font-medium font-montserrat mt-1">
            {passportNumber || "-"}
          </h5>
        </div>

        <div className="mt-14">
          <h6 className="text-theme-slate-600 text-base font-normal font-montserrat">
            for successfully completing;
          </h6>
          <h2 className="text-theme-zinc-700 text-xl font-semibold font-montserrat mt-1.5 max-w-[600px]">
            {courseName || "-"}
          </h2>
        </div>

        <div className="absolute bottom-20 left-20">
          <h6 className="text-theme-slate-600 text-xs font-normal font-montserrat">
            Powered by UpscaleBD Limited
          </h6>
        </div>
      </div>
      {qrCode && (
        <div className="absolute bottom-20 right-20">
          <QRCodeSVG value={qrCode} size={90} />
        </div>
      )}
    </div>
  );
}
